import axios from 'axios';

const baseURL = `${window.location.origin}/api`;

const tdApi = axios.create({ baseURL });

export default tdApi;
